import { mapActions } from 'vuex'
export default {
  async created () {
    await this.fetchPassCardProcess()
  },
  mounted () {
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('user', ['getPassCardProcessStatus']),
    async fetchPassCardProcess () {
      const { success, data } = await this.getPassCardProcessStatus()
      if (success) {
        const smsTemplate = this.$route.query.smsTemplate
        if (data && data.bizTag) {
          // 跳转中间页
          this.$router.push(
            {
              path: '/middle/limit',
              query: smsTemplate ? { smsTemplate } : null
            }
          )
        } else {
          this.$router.replace({
            path: '/',
            query: smsTemplate ? { smsTemplate } : null
          })
        }
      }
    }
  },
  render () {
    return <div />
  }
}